import { TimerStarOutlineIcon } from './TimerStarOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 8C07F7EA-8924-43A8-91E2-55A7D0DAE7AF
 * name timer-star-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-star-outline.svg
 * tags
 * - Date / Time 
 */
export const StopwatchFavoriteOutlineIcon = TimerStarOutlineIcon;
export default StopwatchFavoriteOutlineIcon